import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/category/${video.category}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-video' : 'aspect-video'}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 国产视频大全`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </div>
        {video.isHot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium">
            热门
          </div>
        )}
        {video.isNew && (
          <div className={`absolute top-2 ${video.isHot ? 'left-14' : 'left-2'} bg-accent-500 text-white text-xs px-2 py-0.5 rounded-md font-medium`}>
            新上线
          </div>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {video.title}
        </h3>
        {size === 'large' && (
          <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-3">{video.description}</p>
        )}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 text-accent-500">
            <i className="ri-star-fill text-xs"></i>
            <span className="text-xs font-medium">{video.rating}</span>
          </div>
          <div className="flex items-center gap-1 text-foreground-500">
            <i className="ri-eye-line text-xs"></i>
            <span className="text-xs">
              {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
            </span>
          </div>
        </div>
        {size === 'large' && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {video.tags.map((tag) => (
              <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}